const navButtons = [
  {
    name: "Dashboard",
    url: "/dashboard",
    permission: "none",
    image: "/images/nav-menu/dashboard.png",
  },
  {
    name: "Tenant",
    url: "/tenant-list",
    permission: "tenant",
    image: "/images/nav-menu/tenant.png",
  },
  {
    name: "User",
    url: "/user-list",
    permission: "staff",
    image: "/images/nav-menu/staff.png",
  },
  {
    name: "Permission",
    url: "/permissions-list",
    permission: "permissions",
    image: "/images/nav-menu/permissions.png",
  },
  {
    name: "Appointment",
    url: "/appointment-list",
    permission: "appointments",
    image: "/images/nav-menu/appointment.png",
  },
  {
    name: "Visitor",
    url: "/visitor-list",
    permission: "combined",
    field: "visitor",
    image: "/images/nav-menu/visitor.png",
  },
  {
    name: "Contractor",
    url: "/contractor-list",
    permission: "combined",
    field: "contractor",
    image: "/images/nav-menu/tenants.png",
  },
  // {
  //   name: "Notification",
  //   url: "/notification-list",
  //   permission: "notifications",
  //   image: "/images/nav-menu/notification.png",
  // },
  // {
  //   name: "Security",
  //   url: "/access-list",
  //   permission: "combined",
  //   field: "security",
  //   image: "/images/nav-menu/security.png",
  // },
  // {
  //   name: "Reports",
  //   url: "/reports",
  //   permission: "combined",
  //   field: "reports",
  //   image: "/images/nav-menu/reports.png",
  // },
  {
    name: "History",
    url: "/history-list",
    permission: "combined",
    field: "history",
    image: "/images/nav-menu/history.png",
  },
];

export default navButtons;
